import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import host from '../../urlPath';
//******* 

//--------- INSERT utility
export const sendMessageData = createAsyncThunk("sendMessageData", async (formData, { rejectWithValue }) => {

    const response = await axios.post(`${host}/message_schedule.php`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    try {
        const result = await response.data;
        return result;
    }
    catch (error) {
        return rejectWithValue(error)
    }
})



//--------- INSERT marketing
export const sendMessageDataMarketing = createAsyncThunk("sendMessageDataMarketing", async (formData, { rejectWithValue }) => {

    const response = await axios.post(`${host}/message_schedule_marketing.php`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    try {
        const result = await response.data;
        return result;
    }
    catch (error) {
        return rejectWithValue(error)
    }
})




//=---------- READ
export const showMessageData = createAsyncThunk("showMessageData", async (scheduledt, { rejectWithValue }) => {

    const response = await fetch(`${host}/message_schedule.php/${scheduledt}`, {
        method: "GET", // *GET, POST, PUT, DELETE, etc. 
        headers: {
            "Content-Type": "application/json"
        }
    });
    try {
        const result = await response.json();
        return result;

    } catch (error) {
        return rejectWithValue(error)
    }
})



//=---------- DELETE SCHEDULE
export const deleteDateSchedule = createAsyncThunk("deleteDateSchedule", async (scheduledt, { rejectWithValue }) => {
    console.log(scheduledt)
    const response = await fetch(`${host}/message_schedule.php/${scheduledt}`, {
        method: "DELETE", // *GET, POST, PUT, DELETE, etc. 
        headers: {
            "Content-Type": "application/json"
        }
    });
    try {
        const result = await response.json();
        return result;

    } catch (error) {
        return rejectWithValue(error)
    }
})



//=---------- READ
export const showMessageDataAll = createAsyncThunk("showMessageDataAll", async (scheduledt, { rejectWithValue }) => {

    const response = await fetch(`${host}/message_schedule_all_list.php`, {
        method: "GET", // *GET, POST, PUT, DELETE, etc. 
        headers: {
            "Content-Type": "application/json"
        }
    });
    try {
        const result = await response.json();
        return result;

    } catch (error) {
        return rejectWithValue(error)
    }
})




//*************************************** FOR API END *************************


export const messageSchedule = createSlice({
    name: "messageSchedule",
    initialState: {
        messageImageDataMarketing: [],
        messageClientDataMarketing: [],
        messageScheduleTimeMarketing: [],
        messageImageDataUtility: [],
        messageClientDataUtility: [],
        messageScheduleTimeUtility: [],
        loading: false,
        error: null,
        clientID: [],
        groupID: [],
        modalOpen: false,
        UtilityImageName: "",
        canvasImage: [],
        canvasClientId: [] ,
        messageScheduleAllData: [] 
    },


    //*************************************** FOR WITHOUT API ONLY FUNCTION START *************************   
    reducers: {
        setClientId: (state, action) => {
            // if(state.clientID.includes(action.payload)){
            //     const index = state.clientID.indexOf(action.payload);
            //     state.clientID.splice(index, 1);  
            // }else{
            //     state.clientID.push(action.payload)
            // }

            if (action.payload === "") {
                state.clientID = [];
            }
            else if (state.clientID.includes(action.payload)) {
                const index = state.clientID.indexOf(action.payload);
                state.clientID.splice(index, 1);
            } else {
                state.clientID.push(action.payload)
            }
        },
        setGroupId: (state, action) => {
            // if(state.groupID.includes(action.payload)){
            //     const index = state.groupID.indexOf(action.payload);
            //     state.groupID.splice(index, 1);  
            // }else{
            //     state.groupID.push(action.payload)
            // }
            if (action.payload === "") {
                state.groupID = [];
            }
            else if (state.groupID.includes(action.payload)) {
                const index = state.groupID.indexOf(action.payload);
                state.groupID.splice(index, 1);
            } else {
                state.groupID.push(action.payload)
            }
        },
        setAllClientId: (state, action) => {
            if (action.payload === "") {
                state.clientID = [];
            }
            else {
                state.clientID = action.payload
            }
        },
        setModalOpen: (state, action) => {
            state.modalOpen = action.payload
        },
        setUtilityImageName: (state, action) => {
            state.UtilityImageName = action.payload
        },
        setUploadedCanvasImage: (state, action) => {
            if (action.payload === "") {
                state.canvasImage = [];
            }
            else {
                state.canvasImage.push(action.payload)
            }

        },
        setUploadedCanvasClientId: (state, action) => {
            if (action.payload === "") {
                state.canvasClientId = [];
            }
            else {
                state.canvasClientId.push(action.payload)
            } 
        } 
    },
    //*************************************** FOR WITHOUT API ONLY FUNCTION END *************************




    //*************************************** FOR API START *************************
    extraReducers: (builder) => {

        //-------------------- FOR INSERT utility-------------------------
        builder.addCase(sendMessageData.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(sendMessageData.fulfilled, (state) => {
            state.loading = false;
            //     const result = action.payload; 
            //    const resultArray = JSON.parse(result);
            //    Array.prototype.push.apply(state.messageImageData,resultArray)

        })
        builder.addCase(sendMessageData.rejected, (state) => {
            state.loading = false;
        })
        //---------------------- END --------------------------


        //-------------------- FOR INSERT marketing-------------------------
        builder.addCase(sendMessageDataMarketing.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(sendMessageDataMarketing.fulfilled, (state) => {
            state.loading = false;
            //     const result = action.payload; 
            //    const resultArray = JSON.parse(result);
            //    Array.prototype.push.apply(state.messageImageData,resultArray)

        })
        builder.addCase(sendMessageDataMarketing.rejected, (state) => {
            state.loading = false;
        })
        //---------------------- END --------------------------



        

        //---------------------- FOR SELECT ---------------------------
        builder.addCase(showMessageData.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(showMessageData.fulfilled, (state, action) => {
            state.loading = false;
            //for MARKETING
            state.messageImageDataMarketing = action.payload.image_array_marketing
            state.messageClientDataMarketing = action.payload.client_name_array_marketing
            state.messageScheduleTimeMarketing = action.payload.schedule_time_marketing
            //for UTILITY
            state.messageImageDataUtility = action.payload.image_array_utility
            state.messageClientDataUtility = action.payload.client_name_array_utility
            state.messageScheduleTimeUtility = action.payload.schedule_time_utility
        })
        builder.addCase(showMessageData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        //---------------------- END --------------------------

        
        //---------------------- FOR DELETE ---------------------------
        builder.addCase(deleteDateSchedule.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(deleteDateSchedule.fulfilled, (state) => {
            state.loading = false;
        })
        builder.addCase(deleteDateSchedule.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        //---------------------- END --------------------------


         //---------------------- FOR SELECT ---------------------------
         builder.addCase(showMessageDataAll.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(showMessageDataAll.fulfilled, (state, action) => {
            state.loading = false;
            state.messageScheduleAllData = action.payload
            console.log(state.messageScheduleAllData)
        })
        builder.addCase(showMessageDataAll.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        //---------------------- END --------------------------



        //*************************************** FOR API END ************************* 
    },

});
export default messageSchedule.reducer;
export const { setClientId, setGroupId, setAllClientId, setModalOpen, setUtilityImageName, setUploadedCanvasImage, setUploadedCanvasClientId } = messageSchedule.actions; // FOR EXPORT